export class Referee {
    name: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/referee.model.ts